import React from 'react';
import {Card} from 'antd';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import BreadcrumbToolbar from '../components/layouts/BreadcrumbToolbar'
import StationDeviceDatasToolbar from '../components/StationDeviceDatasToolbar'
import StationDeviceDatasChart from '../components/StationDeviceDatasChart'
import StationDeviceDatasPowerMeterChart from '../components/StationDeviceDatasPowerMeterChart'
import StationDeviceDatasTimelineChart from '../components/StationDeviceDatasTimelineChart';
import {fetchChartDeviceData, fetchTimeLineDeviceData, fetchChartPowerMeterDayData, fetchChartPowerMeterMonthData, exportDeviceData} from '../actions/chart'
import {fetchStationPresentation} from '../actions/station'

import {
  SUB_CATEGORY_TEMPERATURE,
  SUB_CATEGORY_TEMPERATURE_OUTSIDE,
  SUB_CATEGORY_HUMIDITY,
  SUB_CATEGORY_HUMIDITY_OUTSIDE,
  SUB_CATEGORY_V_AC_METER,
  SUB_CATEGORY_LUMINARY,
  SUB_CATEGORY_POWER_METER,
  SUB_CATEGORY_POWER_METER_DAY,
  SUB_CATEGORY_POWER_METER_MONTH
} from '../constants/defaultValues'

class StationDeviceDatas extends React.Component {
  componentWillMount() {
    this.props.dispatch(fetchStationPresentation())
  }

  handleSearch = (timeQuery, from, to, deviceID) => {
    const {devices} = this.props
    const deviceIndex = devices.findIndex((dev) => {
      return dev.DeviceId === deviceID
    })
    const device = deviceIndex > -1
      ? devices[deviceIndex]
      : undefined
    if (device) {
      if (device.SubCategory === SUB_CATEGORY_TEMPERATURE || device.SubCategory === SUB_CATEGORY_TEMPERATURE_OUTSIDE || device.SubCategory === SUB_CATEGORY_HUMIDITY || device.SubCategory === SUB_CATEGORY_HUMIDITY_OUTSIDE || device.SubCategory === SUB_CATEGORY_V_AC_METER || device.SubCategory === SUB_CATEGORY_POWER_METER || device.SubCategory === SUB_CATEGORY_LUMINARY) {
        this.props.dispatch(fetchChartDeviceData(device, timeQuery, from + " 00:00:00", to + " 23:59:59", 0, 20000))
      } else if (device.SubCategory === SUB_CATEGORY_POWER_METER_DAY) {
        this.props.dispatch(fetchChartPowerMeterDayData(device, timeQuery, from + " 00:00:00", to + " 23:59:59", 0, -1))
      } else if (device.SubCategory === SUB_CATEGORY_POWER_METER_MONTH) {
        this.props.dispatch(fetchChartPowerMeterMonthData(device, timeQuery, from + " 00:00:00", to + " 23:59:59", 0, -1))
      } else {
        this.props.dispatch(fetchTimeLineDeviceData(device, timeQuery, from + " 00:00:00", to + " 23:59:59", 0, 20000))
      }
    }
  }

  handleExport = (deviceSelected, timeQuery, from, to) => {
    const {devices} = this.props
    const deviceIndex = devices.findIndex((dev) => {
      return dev.DeviceId === deviceSelected
    })
    const device = deviceIndex > -1
      ? devices[deviceIndex]
      : undefined
    if (device) {
      this.props.dispatch(exportDeviceData(device, timeQuery, from, to))
    }
  }

  render() {
    const {
      currentSystem,
      currentStation,
      devices,
      rooms,
      fetchingDevices,
      deviceSelected,
      timeQuery,
      from,
      to,
      ainChartData,
      dinChartData,
      powerChartData,
      chartFetching
    } = this.props
    const breadcrumbs = [
      {
        Name: "Giám sát",
        Link: `/${currentSystem.ID}/presentation`
      }, {
        Name: currentStation.Name,
        Link: `station/${currentStation.ID}`
      }, {
        Name: "Biểu đồ dữ liệu",
        Link: ""
      }
    ]
    const content = (deviceSelected.SubCategory === SUB_CATEGORY_TEMPERATURE || deviceSelected.SubCategory === SUB_CATEGORY_TEMPERATURE_OUTSIDE || deviceSelected.SubCategory === SUB_CATEGORY_HUMIDITY || deviceSelected.SubCategory === SUB_CATEGORY_HUMIDITY_OUTSIDE || deviceSelected.SubCategory === SUB_CATEGORY_V_AC_METER || deviceSelected.SubCategory === SUB_CATEGORY_POWER_METER || deviceSelected.SubCategory === SUB_CATEGORY_LUMINARY)
      ? <StationDeviceDatasChart ainChartData={ainChartData} device={deviceSelected} fetching={chartFetching}/>
      : deviceSelected.SubCategory === SUB_CATEGORY_POWER_METER_DAY || deviceSelected.SubCategory === SUB_CATEGORY_POWER_METER_MONTH
        ? <StationDeviceDatasPowerMeterChart datas={powerChartData} device={deviceSelected} fetching={chartFetching}/>
        : <StationDeviceDatasTimelineChart datas={dinChartData} device={deviceSelected} fetching={chartFetching}/>
    return <div>
      <div className="toolbar">
        <BreadcrumbToolbar items={breadcrumbs}/>
      </div>
      <Card className="toolbar card" bordered={false} extra={<StationDeviceDatasToolbar fetching = {
          fetchingDevices || chartFetching
        }
        devices = {
          devices
        }
        rooms = {
          rooms
        }
        device = {
          deviceSelected
        }
        timeQuery = {
          timeQuery
        }
        from = {
          from
        }
        to = {
          to
        }
        onSearch = {
          this.handleSearch
        }
        onExport = {
          this.handleExport
        } />}>{content}</Card>
    </div>
  }
}

StationDeviceDatas.propTypes = {
  dispatch: PropTypes.func,
  currentSystem: PropTypes.object,
  currentUser: PropTypes.object,
  currentStation: PropTypes.object,
  devices: PropTypes.array,
  rooms: PropTypes.array,
  deviceSelected: PropTypes.object,
  timeQuery: PropTypes.string,
  from: PropTypes.string,
  to: PropTypes.string,
  ainChartData: PropTypes.array,
  dinChartData: PropTypes.array,
  powerChartData: PropTypes.array,
  fetching: PropTypes.bool,
  fetchingDevices: PropTypes.bool,
  chartFetching: PropTypes.bool,
  error: PropTypes.string
}

const mapStateToProps = function(state) {
  return {
    currentSystem: state.system.currentSystem,
    currentUser: state.user.currentUser,
    currentStation: state.station.currentStation,
    devices: state.device.devices,
    rooms: state.device.rooms,
    deviceSelected: state.chart.deviceSelected,
    timeQuery: state.chart.timeQuery,
    from: state.chart.from,
    to: state.chart.to,
    ainChartData: state.chart.ainChartData,
    dinChartData: state.chart.dinChartData,
    powerChartData: state.chart.powerChartData,
    fetching: state.station.fetching,
    fetchingDevices: state.device.fetchingDevices,
    chartFetching: state.chart.fetching,
    error: state.station.error
  }
}

export default connect(mapStateToProps)(StationDeviceDatas)



// WEBPACK FOOTER //
// ./src/pages/StationDeviceDatas.js